<template>
	<GooglePay class="google-pay" :config="config">
		<!-- Funnel-identical custom visual (med-web-funnel GooglePayButton): slot content puts
		     web-billing into transparent mode — the real Stripe Express Checkout button is
		     overlaid invisible on top, so this black pill is what the user sees while the
		     native button takes the click. -->
		<button type="button" class="google-pay__button">
			<GooglePayIcon class="google-pay__icon" />
		</button>
	</GooglePay>
</template>

<script setup lang="ts">
import { GooglePay } from '@simple-life-app/web-billing'
import type { IPaymentMethodConfig } from '@simple-life-app/web-billing'
import GooglePayIcon from '@/components/payment/GooglePayIcon.vue'

defineProps<{ config: IPaymentMethodConfig }>()
</script>

<style scoped>
.google-pay {
	width: 100%;
}

/* Ported from med-web-funnel's `.btn` base + `.google-pay__button` override — flattened
   to the computed values (this repo has no bootstrap layer to compose from). */
.google-pay__button {
	appearance: none;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	margin: 0;
	padding: 10px var(--size-12); /* funnel --size-10 has no DS counterpart */
	background-color: #000; /* funnel --google-pay-bg-color */
	color: var(--text-white-primary, #fff);
	border: 1px solid transparent;
	border-radius: var(--size-16);
	font-weight: 700;
	font-size: 16px;
	touch-action: manipulation;
	cursor: pointer;
}

.google-pay__icon {
	display: block;
}
</style>
